import { VENDOR_DROP_DOWN_LIST } from '../../constants';

const initialState = {
  data: [],
  loading: true,
  error: {}
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case VENDOR_DROP_DOWN_LIST.LOAD:
      return {
        ...state,
        loading: true
      };
    case VENDOR_DROP_DOWN_LIST.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false
      };
    case VENDOR_DROP_DOWN_LIST.FAIL:
      return {
        ...state,
        error: payload,
        loading: false
      };
    default:
      return state;
  }
}
